"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactAriaTabpanel = require("react-aria-tabpanel");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TabListWrapper = _styledComponents.default.ul.withConfig({
  displayName: "Tabs__TabListWrapper",
  componentId: "jzgyty-0"
})(["display:inline-flex;flex-direction:row;width:100%;padding:0;border-bottom:1px solid #e0e0e0;margin:0;list-style-type:none;"]);

var StyledTab = (0, _styledComponents.default)(_reactAriaTabpanel.Tab).withConfig({
  displayName: "Tabs__StyledTab",
  componentId: "jzgyty-1"
})(["border-top-left-radius:0.5em;border-top-right-radius:0.5em;outline:none;cursor:pointer;&:focus{box-shadow:0 0 0 0.2em ", ";}"], (0, _polished.transparentize)(0.5, '#428bca'));

var TabLabel = _styledComponents.default.div.withConfig({
  displayName: "Tabs__TabLabel",
  componentId: "jzgyty-2"
})(["box-sizing:border-box;padding:0.375em 0.75em;border-color:", ";border-style:solid;border-top-left-radius:0.5em;border-top-right-radius:0.5em;border-width:1px 1px 0 1px;color:", ";"], function (props) {
  return props.isActive ? '#428bca' : '#e0e0e0';
}, function (props) {
  return props.isActive ? '#428bca' : 'inherit';
});

var StyledTabPanel = (0, _styledComponents.default)(_reactAriaTabpanel.TabPanel).withConfig({
  displayName: "Tabs__StyledTabPanel",
  componentId: "jzgyty-3"
})(["padding:0.5em;"]);

var Tabs = function Tabs(_ref) {
  var activeTabProp = _ref.activeTabId,
      tabs = _ref.tabs,
      _onChange = _ref.onChange;

  var _useState = (0, _react.useState)(tabs[0].id),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabState = _useState2[0],
      setActiveTabState = _useState2[1];

  var activeTabId = activeTabProp || activeTabState;
  return /*#__PURE__*/_react.default.createElement(_reactAriaTabpanel.Wrapper, {
    activeTabId: activeTabId,
    onChange: function onChange(tabId) {
      setActiveTabState(tabId);

      _onChange(tabId);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactAriaTabpanel.TabList, null, /*#__PURE__*/_react.default.createElement(TabListWrapper, null, tabs.map(function (tab) {
    var id = tab.id,
        label = tab.label;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: id
    }, /*#__PURE__*/_react.default.createElement(StyledTab, {
      active: id === activeTabId,
      id: id
    }, function (_ref2) {
      var isActive = _ref2.isActive;
      return /*#__PURE__*/_react.default.createElement(TabLabel, {
        isActive: isActive
      }, label);
    }));
  }))), /*#__PURE__*/_react.default.createElement("div", null, tabs.map(function (tab) {
    var id = tab.id,
        render = tab.render;
    return /*#__PURE__*/_react.default.createElement(StyledTabPanel, {
      key: id,
      active: id === activeTabId,
      tabId: id
    }, render());
  })));
};

exports.Tabs = Tabs;
Tabs.propTypes = {
  activeTabId: _propTypes.default.string,
  tabs: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    render: _propTypes.default.func.isRequired
  })).isRequired,
  onChange: _propTypes.default.func
};
Tabs.defaultProps = {
  activeTabId: undefined,
  onChange: function onChange() {}
};